import {
  ActionViewModel,
  ActionViewModelImplementation,
  Effector,
} from "./ActionViewModel";
import { advancedHolding, advancedQuick } from "./advanced";
import { CarbonUser } from "common/utils/auth";
import {
  engageLaserWeeder,
  laserweederEstopOff,
  laserweederEstopOn,
} from "./laserweeder";
import { engineRpmMax, engineRpmMin } from "./engineRpm";
import { hitchFloat, hitchSetPosition, hitchTimedForce } from "./hitch";
import { ptoEngaged } from "./pto";
import { QuickAction } from "protos/atk/activities";
import { RigEffectiveConfig } from "protos/atk/effective_config";
import {
  scvConstantPressure,
  scvDetentDown,
  scvDetentUp,
  scvFloat,
  scvTimedForce,
} from "./scvBasic";
import { scvSetPosition } from "./scvPositionMonitored";

const IMPLEMENTATIONS = [
  scvDetentUp,
  scvDetentDown,
  scvTimedForce,
  scvFloat,
  scvConstantPressure,
  scvSetPosition,
  hitchTimedForce,
  hitchSetPosition,
  hitchFloat,
  engineRpmMax,
  engineRpmMin,
  ptoEngaged,
  engageLaserWeeder,
  laserweederEstopOn,
  laserweederEstopOff,
  advancedQuick,
  advancedHolding,
] as const;

export function validActionsForEffector(
  user: CarbonUser | undefined,
  effector: Effector,
  rigEffectiveConfig: RigEffectiveConfig
): ActionViewModelImplementation<unknown>[] {
  return IMPLEMENTATIONS.filter((impl) =>
    impl.isNewActionAvailableForEffector(user, effector, rigEffectiveConfig)
  ) as ActionViewModelImplementation<unknown>[];
}

export function quickActionToViewModel(
  action: QuickAction,
  startInStageIndex: number
): ActionViewModel<unknown> | undefined {
  for (const impl of IMPLEMENTATIONS) {
    const viewModel = impl.fromQuickAction(action, startInStageIndex);

    if (viewModel) {
      return viewModel as ActionViewModel<unknown>;
    }
  }

  console.warn(
    `quickActionToViewModel: can't process action ${JSON.stringify(
      action
    )}; ignoring`
  );
}
